var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFunction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 4.58333C13.75 3.85398 13.4603 3.15451 12.9445 2.63878C12.4288 2.12306 11.7293 1.83333 11 1.83333C10.2707 1.83333 9.57118 2.12306 9.05546 2.63878C8.53973 3.15451 8.25 3.85398 8.25 4.58333V17.4167C8.25 18.146 8.53973 18.8455 9.05546 19.3612C9.57118 19.8769 10.2707 20.1667 11 20.1667C11.7293 20.1667 12.4288 19.8769 12.9445 19.3612C13.4603 18.8455 13.75 18.146 13.75 17.4167V4.58333ZM13.75 9.31058L17.0697 12.6298C17.4148 12.9673 17.879 13.1551 18.3617 13.1525C18.8444 13.1498 19.3065 12.9569 19.6478 12.6156C19.9892 12.2744 20.1822 11.8122 20.1849 11.3296C20.1876 10.8469 19.9999 10.3826 19.6625 10.0375L13.75 4.12499V9.31058Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28254 12.5648L4.96283 9.2455C4.79372 9.0704 4.59142 8.93073 4.36774 8.83465C4.14407 8.73857 3.9035 8.68799 3.66007 8.68588C3.41664 8.68376 3.17523 8.73015 2.94992 8.82233C2.72461 8.91451 2.51991 9.05064 2.34778 9.22278C2.17564 9.39491 2.03951 9.59961 1.94733 9.82492C1.85515 10.0502 1.80876 10.2916 1.81088 10.5351C1.81299 10.7785 1.86357 11.0191 1.95965 11.2427C2.05573 11.4664 2.1954 11.6687 2.3705 11.8378L8.283 17.7503L8.28254 12.5648Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 4.58333V5.04166M11 16.9583V17.4167",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunction);
export default __webpack_public_path__ + "static/media/function.b067fb83687b871453b65e530ea342a5.svg";
export { ForwardRef as ReactComponent };